import React, { useEffect } from 'react';
import Seo from '../components/Seo';
import { Link } from 'react-router-dom';
import '../styles/services.css';

/* ---- 와이어프레임 SVG (아트보드 / 브라우저 / 폰) ---- */
const Artboard = () => (
  <svg width="300" height="230" viewBox="0 0 300 230" role="img" aria-label="아트보드 와이어프레임">
    <rect x="8" y="8" width="284" height="214" rx="10" className="wf-dim" />
    <line x1="8" y1="34" x2="292" y2="34" className="wf-dim" />
    <circle cx="22" cy="21" r="3" className="wf-dot" />
    <circle cx="33" cy="21" r="3" className="wf-dim" />
    <circle cx="44" cy="21" r="3" className="wf-dim" />
    <text x="150" y="24" textAnchor="middle" className="wf-txt">ARTBOARD · 1440</text>
    <rect x="22" y="48" width="70" height="160" rx="6" className="wf-fill-2" />
    <rect x="32" y="60" width="42" height="6" rx="3" className="wf-line" />
    <rect x="32" y="74" width="50" height="4" rx="2" className="wf-dim" />
    <rect x="32" y="84" width="34" height="4" rx="2" className="wf-dim" />
    <rect x="32" y="94" width="46" height="4" rx="2" className="wf-dim" />
    <rect x="106" y="48" width="170" height="72" rx="6" className="wf-fill" />
    <rect x="118" y="64" width="90" height="8" rx="4" className="wf-line" />
    <rect x="118" y="80" width="130" height="5" rx="2.5" className="wf-dim" />
    <rect x="118" y="90" width="110" height="5" rx="2.5" className="wf-dim" />
    <rect x="118" y="102" width="46" height="10" rx="5" className="wf-line" />
    <rect x="106" y="130" width="52" height="52" rx="6" className="wf-fill-2" />
    <rect x="165" y="130" width="52" height="52" rx="6" className="wf-fill-2" />
    <rect x="224" y="130" width="52" height="52" rx="6" className="wf-fill-2" />
    <circle cx="132" cy="150" r="8" className="wf-line" />
    <circle cx="191" cy="150" r="8" className="wf-dim" />
    <circle cx="250" cy="150" r="8" className="wf-dim" />
    <rect x="118" y="168" width="28" height="4" rx="2" className="wf-dim" />
    <rect x="177" y="168" width="28" height="4" rx="2" className="wf-dim" />
    <rect x="236" y="168" width="28" height="4" rx="2" className="wf-dim" />
    <line x1="106" y1="196" x2="276" y2="196" className="wf-line" strokeDasharray="3 4" />
    <text x="191" y="210" textAnchor="middle" className="wf-txt">GRID · 8PT</text>
  </svg>
);

const BrowserWF = () => (
  <svg width="300" height="230" viewBox="0 0 300 230" role="img" aria-label="브라우저 와이어프레임">
    <rect x="8" y="20" width="284" height="192" rx="10" className="wf-dim" />
    <line x1="8" y1="46" x2="292" y2="46" className="wf-dim" />
    <circle cx="22" cy="33" r="3.2" className="wf-dot" />
    <circle cx="33" cy="33" r="3.2" className="wf-dim" />
    <circle cx="44" cy="33" r="3.2" className="wf-dim" />
    <rect x="58" y="28" width="200" height="11" rx="5.5" className="wf-fill-2" />
    <text x="66" y="36" className="wf-txt">https://ezylab.app</text>
    <rect x="22" y="58" width="60" height="8" rx="4" className="wf-line" />
    <rect x="210" y="58" width="30" height="8" rx="4" className="wf-dim" />
    <rect x="248" y="58" width="30" height="8" rx="4" className="wf-dim" />
    <rect x="22" y="80" width="150" height="70" rx="6" className="wf-fill" />
    <rect x="34" y="94" width="88" height="8" rx="4" className="wf-line" />
    <rect x="34" y="110" width="120" height="5" rx="2.5" className="wf-dim" />
    <rect x="34" y="120" width="100" height="5" rx="2.5" className="wf-dim" />
    <rect x="34" y="132" width="40" height="10" rx="5" className="wf-line" />
    <rect x="182" y="80" width="96" height="70" rx="6" className="wf-fill-2" />
    <path d="M196 132 L214 110 L230 124 L250 96 L264 116" className="wf-line" />
    <circle cx="214" cy="110" r="2.4" className="wf-dot" />
    <circle cx="250" cy="96" r="2.4" className="wf-dot" />
    <rect x="22" y="162" width="256" height="10" rx="3" className="wf-fill-2" />
    <rect x="22" y="178" width="256" height="9" rx="3" className="wf-dim" fill="none" />
    <rect x="22" y="192" width="256" height="9" rx="3" className="wf-dim" fill="none" />
    <line x1="120" y1="162" x2="120" y2="201" className="wf-dim" />
    <line x1="200" y1="162" x2="200" y2="201" className="wf-dim" />
  </svg>
);

const PhoneWF = () => (
  <svg width="300" height="230" viewBox="0 0 300 230" role="img" aria-label="모바일 앱 와이어프레임">
    <rect x="108" y="6" width="84" height="218" rx="18" className="wf-dim" />
    <rect x="114" y="12" width="72" height="206" rx="13" className="wf-fill-2" />
    <rect x="134" y="17" width="32" height="4" rx="2" className="wf-dim" />
    <rect x="122" y="30" width="40" height="7" rx="3.5" className="wf-line" />
    <circle cx="178" cy="33" r="5" className="wf-dim" />
    <rect x="122" y="44" width="56" height="40" rx="6" className="wf-fill" />
    <rect x="129" y="52" width="30" height="6" rx="3" className="wf-line" />
    <rect x="129" y="64" width="42" height="4" rx="2" className="wf-dim" />
    <rect x="129" y="72" width="34" height="4" rx="2" className="wf-dim" />
    <circle cx="130" cy="98" r="6" className="wf-line" />
    <rect x="142" y="94" width="36" height="4" rx="2" className="wf-dim" />
    <rect x="142" y="101" width="24" height="3" rx="1.5" className="wf-dim" />
    <circle cx="130" cy="118" r="6" className="wf-dim" />
    <rect x="142" y="114" width="36" height="4" rx="2" className="wf-dim" />
    <rect x="142" y="121" width="28" height="3" rx="1.5" className="wf-dim" />
    <circle cx="130" cy="138" r="6" className="wf-dim" />
    <rect x="142" y="134" width="36" height="4" rx="2" className="wf-dim" />
    <rect x="142" y="141" width="20" height="3" rx="1.5" className="wf-dim" />
    <line x1="122" y1="196" x2="178" y2="196" className="wf-dim" />
    <circle cx="134" cy="206" r="3.4" className="wf-dot" />
    <circle cx="150" cy="206" r="3.4" className="wf-dim" />
    <circle cx="166" cy="206" r="3.4" className="wf-dim" />
    <line x1="196" y1="44" x2="230" y2="44" className="wf-line" strokeDasharray="2 4" />
    <text x="234" y="47" className="wf-txt">iOS</text>
    <line x1="196" y1="84" x2="230" y2="84" className="wf-line" strokeDasharray="2 4" />
    <text x="234" y="87" className="wf-txt">AOS</text>
    <line x1="70" y1="118" x2="104" y2="118" className="wf-dim" strokeDasharray="2 4" />
    <text x="26" y="121" className="wf-txt">PUSH</text>
  </svg>
);

const GFX = { artboard: Artboard, browser: BrowserWF, phone: PhoneWF };

const SERVICES = [
  {
    num: '01', en: 'UI / UX DESIGN', title: 'UI/UX 디자인', gfx: 'artboard',
    promise: <>쓰기 쉬운 인터페이스와 <b>확장 가능한 디자인 시스템</b>을 설계합니다. 리서치에서 프로토타입까지, 일관된 사용자 경험을 만듭니다.</>,
    chips: ['UX 리서치', 'IA', '와이어프레임', 'UI', '프로토타입', '디자인 시스템'],
    stack: ['Figma', 'Framer'],
  },
  {
    num: '02', en: 'WEB DEVELOPMENT', title: '웹 개발', gfx: 'browser',
    promise: <>반응형 웹부터 <b>복잡한 웹앱과 관리자 시스템</b>까지. 안정적으로 확장되는 서비스를 설계하고 배포합니다.</>,
    chips: ['반응형', 'SPA', 'CMS', 'API', '결제/인증', '배포'],
    stack: ['React', 'Next.js', 'Spring Boot', 'AWS'],
  },
  {
    num: '03', en: 'MOBILE APP', title: '모바일 앱 개발', gfx: 'phone',
    promise: <>iOS·Android <b>네이티브와 크로스플랫폼</b>, 스토어 출시까지. 손안에서 매끄럽게 작동하는 앱을 만듭니다.</>,
    chips: ['네이티브', '크로스플랫폼', '푸시', '소셜로그인', '인앱결제', '스토어등록'],
    stack: ['React Native', 'Flutter', 'Swift', 'Kotlin'],
  },
];

const STEPS = [
  { n: '01', t: '발견', d: '문제와 목표를 정의하고 성공 기준을 함께 맞춥니다.' },
  { n: '02', t: '설계', d: '정보 구조와 화면, 기술 아키텍처를 설계합니다.' },
  { n: '03', t: '개발', d: '짧은 주기로 구현하고 실제 동작으로 검증합니다.' },
  { n: '04', t: '런칭', d: '배포와 스토어 출시, QA까지 안정적으로 진행합니다.' },
  { n: '05', t: '운영', d: '지표를 보며 개선하고 지속적으로 함께 성장합니다.' },
];

const METRICS = [
  { to: 20, suffix: '+', cap: '완료 프로젝트' },
  { to: 80, suffix: '%', cap: '재의뢰율' },
  { to: 8, suffix: '주', cap: '평균 출시 기간' },
];

const Services = () => {
  useEffect(() => {
    const html = document.documentElement;
    html.classList.add('svc-snap');

    const root = document.querySelector('.svcm');
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const cleanups = [];

    if (!root || reduce || !('IntersectionObserver' in window)) {
      if (root) {
        root.querySelectorAll('.r, .step').forEach((el) => el.classList.add('in'));
        root.querySelectorAll('.count').forEach((el) => { el.textContent = el.getAttribute('data-to'); });
      }
    } else {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
      root.querySelectorAll('.r').forEach((el) => io.observe(el));
      cleanups.push(() => io.disconnect());

      const stepIO = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const idx = Number(e.target.dataset.i) || 0;
          setTimeout(() => e.target.classList.add('in'), idx * 140);
          stepIO.unobserve(e.target);
        });
      }, { threshold: 0.3 });
      root.querySelectorAll('.step').forEach((el, i) => { el.dataset.i = i; stepIO.observe(el); });
      cleanups.push(() => stepIO.disconnect());

      const countIO = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          countIO.unobserve(e.target);
          const el = e.target;
          const to = Number(el.getAttribute('data-to')) || 0;
          const dur = 1400; let start = null;
          const tick = (ts) => {
            if (start === null) start = ts;
            const p = Math.min((ts - start) / dur, 1);
            el.textContent = Math.round((1 - Math.pow(1 - p, 3)) * to);
            if (p < 1) requestAnimationFrame(tick); else el.textContent = to;
          };
          requestAnimationFrame(tick);
        });
      }, { threshold: 0.6 });
      root.querySelectorAll('.count').forEach((el) => countIO.observe(el));
      cleanups.push(() => countIO.disconnect());
    }

    return () => { html.classList.remove('svc-snap'); cleanups.forEach((fn) => fn()); };
  }, []);

  return (
    <div className="services-page svcm">
      <Seo
        title="서비스"
        description="웹사이트·모바일 앱·UI/UX 디자인까지. 발견에서 운영까지 5단계로 진행하는 이지랩의 개발 서비스를 안내합니다."
        path="/services"
      />
      {/* ACT 1 — HOOK */}
      <section className="act hook" aria-label="소개">
        <div className="inner">
          <span className="eyebrow r d1">EzyLab / Software Studio</span>
          <h1>
            <span className="r d2">기획서가 아니라,</span><br />
            <span className="r d3"><span className="accent">작동하는 제품</span>을</span><br />
            <span className="r d4">드립니다<span className="dim">.</span></span>
          </h1>
          <p className="sub r d5">웹, 앱, UI/UX. 아이디어를 실제로 출시되는 제품으로 만드는 엔지니어링 스튜디오 EzyLab의 서비스를 소개합니다.</p>
        </div>
        <div className="scrollcue r d6" aria-hidden="true">
          <span>Scroll</span>
          <span className="track" />
        </div>
      </section>

      {/* SERVICE ACTS */}
      {SERVICES.map((s) => {
        const Gfx = GFX[s.gfx];
        return (
          <section className="act svc" aria-label={s.title} key={s.num}>
            <div className="inner">
              <div className="col">
                <div className="num r d1">{s.num}<span className="ghost">{s.num}</span></div>
                <div className="meta r d1"><span className="bar" />{s.en}</div>
                <h2 className="r d2">{s.title}</h2>
                <p className="promise r d3">{s.promise}</p>
                <div className="chips r d4">
                  {s.chips.map((c) => <span key={c} className="chip">{c}</span>)}
                </div>
                <div className="stack r d5">
                  <span className="lbl">STACK</span>
                  {s.stack.map((t, i) => (
                    <React.Fragment key={t}>{i > 0 && <span className="sep">·</span>} {t}</React.Fragment>
                  ))}
                </div>
              </div>
              <div className="gfx r d3" aria-hidden="true">
                <div className="glow" />
                <div className="frame"><Gfx /></div>
              </div>
            </div>
          </section>
        );
      })}

      {/* PROCESS */}
      <section className="act proc" aria-label="진행 과정">
        <div className="inner">
          <div className="head">
            <div className="meta r d1"><span className="bar" />HOW WE WORK</div>
            <h2 className="r d2">발견에서 운영까지, 5단계로 만듭니다.</h2>
          </div>
          <div className="steps">
            {STEPS.map((s) => (
              <div className="step r" key={s.n}>
                <div className="sn">{s.n}</div>
                <div>
                  <div className="st">{s.t}</div>
                  <div className="sd">{s.d}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* METRICS */}
      <section className="act metrics" aria-label="성과">
        <div className="inner">
          <div className="meta r d1 meta--center"><span className="bar" />PROOF<span className="bar" /></div>
          <h2 className="metrics__title r d2">숫자로 증명합니다.</h2>
          <div className="grid">
            {METRICS.map((m, i) => (
              <div className={`metric r d${i + 2}`} key={m.cap}>
                <div className="big"><span className="count" data-to={m.to}>0</span><span className="suffix">{m.suffix}</span></div>
                <div className="cap">{m.cap}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="act cta" aria-label="상담 신청">
        <div className="inner">
          <div className="meta r d1 meta--center"><span className="bar" />START A PROJECT<span className="bar" /></div>
          <h2 className="r d2">프로젝트를 시작할 <span className="accent">준비</span>가 되셨나요?</h2>
          <Link className="cta-btn r d3" to="/contact">상담 신청<span className="arw" aria-hidden="true">→</span></Link>
          <div className="foot r d4">EZYLAB · 웹 · 앱 · UI/UX</div>
        </div>
      </section>
    </div>
  );
};

export default Services;
